import React, {useEffect, useState} from 'react';
import Avatar from '@material-ui/core/Avatar'
import {useDispatch, useSelector} from 'react-redux'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {hideAuthLoader, userSignOut} from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';
import {getprofile} from "../../api/api";
import {Link} from "react-router-dom";
import {
    checkAgent,saveShareToken,saveDamane
} from 'actions/Auth';

const UserInfo = () => {

    const dispatch = useDispatch();
    const {agentMode} = useSelector(({auth}) => auth);

    const [anchorE1, setAnchorE1] = useState(null);
    const [open, setOpen] = useState(false);
    const [name, setName] = useState(false);
    const [family, setFamily] = useState(false);
    const [agentname, setAgentname] = useState('');
    const [agent, setAgent] = useState('');



    useEffect(() => {
        getprofile()
            .then((response) => {

                console.log('agent');
                console.log(response.data);

                setName(response.data.Details.name);
                setFamily(response.data.Details.family);
                if (response.data.agentname === '') {
                    setAgent(false)
                    dispatch(checkAgent(true));
                } else {
                    setAgent(true)
                    dispatch(checkAgent(false));
                }
                dispatch(saveShareToken(response.data.Details.sharetoken));
                dispatch(saveDamane(response.data.Details.damane))
                setAgentname(response.data.agentname);

                debugger;

            })
            .catch((error) => {


            });

    }, []);


    const handleClick = event => {
        setOpen(true);
        setAnchorE1(event.currentTarget);
    };

    const handleRequestClose = () => {
        setOpen(false);
    };

    return (
        <div className="user-profile d-flex flex-row align-items-center">
            {/*<Avatar*/}
            {/*  alt='...'*/}
            {/*  src={"https://via.placeholder.com/150x150"}*/}
            {/*  className="user-avatar "*/}
            {/*/>*/}
            <img src={require("assets/images/applogo36.png")} alt="jambo" title="jambo"/>
            <div className="user-detail">
                <h4 className="user-name d-flex" style={{marginRight: 10}} onClick={handleClick}>

                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <span style={{fontWeight:'bold'}} className='text-truncate'>
                         {name} {family}
                        </span>
                        {agent ?
                            <span style={{marginTop: 10}} className='text-truncate'>
                       کارپرداز : {agentname}
                        </span>
                            :
                            null
                        }

                    </div>


                    {/*    <i*/}
                    {/*className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>*/}
                </h4>
            </div>
            {/*<Menu className="user-info"*/}
            {/*      id="simple-menu"*/}
            {/*      anchorEl={anchorE1}*/}
            {/*      open={open}*/}
            {/*      onClose={handleRequestClose}*/}
            {/*      PaperProps={{*/}
            {/*        style: {*/}
            {/*          minWidth: 120,*/}
            {/*          paddingTop: 0,*/}
            {/*          paddingBottom: 0*/}
            {/*        }*/}
            {/*      }}*/}
            {/*>*/}
            {/*  <MenuItem onClick={handleRequestClose}>*/}
            {/*    <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>*/}
            {/*    <IntlMessages id="popup.profile"/>*/}
            {/*  </MenuItem>*/}
            {/*  /!*<MenuItem onClick={handleRequestClose}>*!/*/}
            {/*    /!*<i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>*!/*/}
            {/*    /!*<IntlMessages id="popup.setting"/>*!/*/}
            {/*  /!*</MenuItem>*!/*/}
            {/*  <MenuItem onClick={() => {*/}
            {/*    handleRequestClose();*/}
            {/*    dispatch(userSignOut());*/}
            {/*  }}>*/}
            {/*    <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>*/}

            {/*    <IntlMessages id="popup.logout"/>*/}
            {/*  </MenuItem>*/}
            {/*</Menu>*/}
        </div>
    );
};

export default UserInfo;


